import Transform from "@ember-data/serializer/transform";
export default class OncologiesTransform extends Transform {
  deserialize(serialized) {
    serialized?.forEach(oncology => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (oncology.consultation) {
        oncology.consultation = new Date(oncology.consultation);
      }
    });
    return serialized;
  }
  serialize(deserialized) {
    return deserialized;
  }
}